import { refresh } from "../api/refreshApi";
import { setTokens } from "./tokens";
import { isAccountRevokedError, getAuthErrorMessage } from "./authErrors";

import { setUser } from "../redux/modules/userSlice";

export const setRemember = (val) => {
  localStorage.setItem("remember", val ? "1" : "0");
};

export const getRemember = () => {
  const v = localStorage.getItem("remember");
  if (v === "1") return true;
  if (v === "0") return false;
  // fallback: якщо ключ не виставлений, вважатимемо false
  return false;
};

export const refreshToken = async (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    refresh()
      .then((data) => {
        setTokens(data.tokens);

        // Preserve referralId from current state if it exists and new data doesn't have it
        const currentUser = getState?.()?.user?.currentUser;
        const updatedUser = {
          ...data.user,
          // Preserve referralId if it exists in current state and is not in new data
          referralId: data.user?.referralId || currentUser?.referralId,
        };

        dispatch(setUser(updatedUser));
        resolve(data);
      })
      .catch((err) => {
        if (isAccountRevokedError(err)) {
          reject({
            revoked: true,
            revokedMessage: getAuthErrorMessage(err),
          });
          return;
        }
        reject(err);
      });
  });
};
